import { LabelInfo } from './get-recomendations'

type CopiesPerRoll = number
type NumberOfRolls = number

/**
 * Возвращает количество роликов, в которые возможно сматать
 * больше инфо в тесте
 *
 * @param data - этикетки и копии по ручьям
 * @param winding - необходимая намотка
 * @returns
 */
export default function getRolls(
    data: LabelInfo[],
    winding: number
): Map<CopiesPerRoll, NumberOfRolls> {
    const rolls = new Map<CopiesPerRoll, NumberOfRolls>()

    data.forEach(([, copies]) => {
        let restOfCopies = copies

        while (restOfCopies > 0 && winding > 0) {
            const slice = restOfCopies < winding ? restOfCopies : winding
            restOfCopies -= slice
            rolls.set(slice, (rolls.get(slice) || 0) + 1)
        }
    })

    return rolls
}
